import { IconPei } from "../../../components/Icon/Icon.tsx";
import ListNomenclature from "../../../components/NomenclatureComponent/ListNomenclature.tsx";
import NOMENCLATURE from "../../../enums/NomenclaturesEnum.tsx";
import { URLS } from "../../../routes.tsx";

const ListDiametre = () => {
  return (
    <>
      <ListNomenclature
        pageTitle="Diamètres"
        addButtonTitle={"Ajouter un diamètre"}
        pageIcon={<IconPei />}
        lienPageAjout={URLS.ADD_DIAMETRE}
        typeNomenclature={NOMENCLATURE.DIAMETRE}
        lienPageUpdate={URLS.UPDATE_DIAMETRE}
      />
    </>
  );
};

export default ListDiametre;
